import loading from './loading'
import touchmove from './touchmove'
import stableWidth from './stableWidth'

export default {
  install(Vue) {
    Vue.directive('loading', loading)
    Vue.directive('touchmove', touchmove)
    Vue.directive('stable-width', stableWidth)
  },
}
